var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiveFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.3a.8.8 0 01.8-.8h11.4a.8.8 0 01.8.8v9.4a.8.8 0 01-.8.8H2.3a.8.8 0 01-.8-.8V3.3z",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3l5.556 3.704a.8.8 0 00.888 0L14 3",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSAzLjNDMS41IDIuODU4MTcgMS44NTgxNyAyLjUgMi4zIDIuNUgxMy43QzE0LjE0MTggMi41IDE0LjUgMi44NTgxNyAxNC41IDMuM1YxMi43QzE0LjUgMTMuMTQxOCAxNC4xNDE4IDEzLjUgMTMuNyAxMy41SDIuM0MxLjg1ODE3IDEzLjUgMS41IDEzLjE0MTggMS41IDEyLjdWMy4zWiIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yIDNMNy41NTYyNCA2LjcwNDE2QzcuODI0OTYgNi44ODMzMSA4LjE3NTA0IDYuODgzMzEgOC40NDM3NiA2LjcwNDE2TDE0IDMiIHN0cm9rZT0iIzdEODA4NSIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPC9zdmc+Cg==";
export { SvgReceiveFolder as ReactComponent };